import { render, staticRenderFns } from "./CreateCaNonCa.vue?vue&type=template&id=1512b3b8&scoped=true&"
import script from "./CreateCaNonCa.vue?vue&type=script&lang=js&"
export * from "./CreateCaNonCa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1512b3b8",
  null
  
)

export default component.exports